import React from "react";

export const BlogPagination = ({ totalPages, currentPage, onPageChange }) => {
    const handlePageChange = page => {
        if (page !== currentPage && page >= 1 && page <= totalPages) {
            onPageChange(page);
        }
    };

    const renderPageNumbers = () => {
        const pages = [];
        const maxVisiblePages = 3;

        let startPage = Math.max(1, currentPage - 1);
        let endPage = Math.min(totalPages, currentPage + 1);

        if (currentPage === 1) {
            endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);
        } else if (currentPage === totalPages) {
            startPage = Math.max(1, endPage - maxVisiblePages + 1);
        }

        for (let page = startPage; page <= endPage; page++) {
            pages.push(
                <li key={page} className={`page-item ${page === currentPage ? "active" : ""}`}>
                    <a
                        className="page-link"
                        href="#"
                        onClick={e => {
                            e.preventDefault();
                            handlePageChange(page);
                        }}>
                        {page}
                    </a>
                </li>
            );
        }
        return pages;
    };

    return (
        <nav aria-label="Page navigation">
            <ul className="pagination justify-content-center">
                <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                    <a
                        className="page-link"
                        href="#"
                        aria-label="Previous"
                        onClick={e => {
                            e.preventDefault();
                            handlePageChange(currentPage - 1);
                        }}>
                        <span aria-hidden="true">&laquo;</span>
                    </a>
                </li>
                {renderPageNumbers()}
                <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                    <a
                        className="page-link"
                        href="#"
                        aria-label="Next"
                        onClick={e => {
                            e.preventDefault();
                            handlePageChange(currentPage + 1);
                        }}>
                        <span aria-hidden="true">&raquo;</span>
                    </a>
                </li>
            </ul>
        </nav>
    );
};

export default BlogPagination;
